import { render, staticRenderFns } from "./issue-reports.vue?vue&type=template&id=3fcf8743"
import script from "./issue-reports.vue?vue&type=script&lang=js"
export * from "./issue-reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports